import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _dec2, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { reduxForm, initialize } from 'redux-form';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { UserSettingsForm, PageHeader, Snackbar, ButtonBar, ModalTopBar } from 'components';
import { ModalLayout, Navbar } from 'containers';
import { updateUserSettings } from 'redux/modules/userSettings';
import { updateUser } from 'redux/modules/auth';
var UserSettings = (_dec = reduxForm({
  form: 'userSettingsForm'
}), _dec2 = connect(function (state) {
  return {
    user: state.auth.user
  };
}, {
  initialize: initialize,
  updateUserSettings: updateUserSettings,
  updateUser: updateUser
}), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(UserSettings, _Component);

  var _super = _createSuper(UserSettings);

  function UserSettings(props) {
    var _this;

    _classCallCheck(this, UserSettings);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var u = _this.props.user;

      _this.props.initialize('userSettingsForm', {
        firstName: u && u.firstName ? u.firstName : null,
        lastName: u && u.lastName ? u.lastName : null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCancel", function () {
      _this.context.router.goBack();
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (values) {
      var newSettings = {
        avatarUrl: values.avatarUrl
      };

      if (values.password && values.password.length) {
        newSettings.password = values.password;
      }

      if (values.firstName && values.firstName.length) {
        newSettings.firstName = values.firstName;
      }

      if (values.lastName && values.lastName.length) {
        newSettings.lastName = values.lastName;
      }

      if (!values.password && _this.props.requirePassword) {
        alert('You need to create a password.');
        return false;
      }

      _this.props.updateUserSettings(newSettings).then(function (newUserData) {
        _this.props.updateUser(newUserData.data);

        _this.setState({
          snackbarOpen: true
        });
      }).then(function () {
        if (_this.props.redirectOnSubmitUrl) {
          //          browserHistory.push(this.props.redirectOnSubmitUrl);
          location = "".concat(location.origin).concat(_this.props.redirectOnSubmitUrl);
        }
      });
    });

    _this.state = {
      prevPath: '',
      snackbarOpen: false
    };
    return _this;
  }

  _createClass(UserSettings, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isModal = _this$props.isModal,
          handleSubmit = _this$props.handleSubmit;
      var modalView = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Snackbar, {
        message: "Your settings have been updated.",
        open: this.state.snackbarOpen,
        autoHideDuration: 4000
      }), !this.props.noModalTopBar && /*#__PURE__*/React.createElement(ModalTopBar, {
        userScreen: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid"
      }, this.props.includePageHeader && /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          justifyContent: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          maxWidth: 350
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "User Settings",
        style: {
          marginTop: 32
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          justifyContent: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '0 36px',
          maxWidth: 350
        }
      }, /*#__PURE__*/React.createElement(UserSettingsForm, {
        page: this.state.settingType,
        onSubmit: this.handleSubmit,
        handleCancel: this.handleCancel
      })))));
      var nonModalView = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Helmet, {
        title: "User Settings"
      }), /*#__PURE__*/React.createElement(Navbar, {
        position: "fixed",
        text: "Likeable",
        params: _objectSpread({}, this.props.params)
      }), /*#__PURE__*/React.createElement(ModalTopBar, {
        userScreen: true
      }), /*#__PURE__*/React.createElement(ModalLayout, null, modalView));
      return /*#__PURE__*/React.createElement("div", null, isModal ? modalView : nonModalView);
    }
  }]);

  return UserSettings;
}(Component), _defineProperty(_class2, "propTypes", {
  updateUserSettings: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  isModal: PropTypes.bool,
  initialize: PropTypes.func.isRequired
}), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object.isRequired
}), _defineProperty(_class2, "defaultProps", {
  noModalTopBar: false,
  includePageHeader: true,
  redirectOnSubmitUrl: null,
  requirePassword: false
}), _temp)) || _class) || _class);
export { UserSettings as default };